import React from 'react';
import { titleCaps, applyAlbumFilter } from '../utils';


const albumCovers = [
    { name: "new", pic:`${process.env.PUBLIC_URL}/assets/headerPictures/android-chrome-192x192.png` },
    { name: "broodzilla", hide_pic_view: true, pic:`${process.env.PUBLIC_URL}/assets/headerPictures/broodzilla.webp` },
    { name: "meh monday", hide_pic_view: true, pic:`${process.env.PUBLIC_URL}/assets/headerPictures/meh-monday.webp` },
    { name: "cooking", hide_pic_view: true, pic:`${process.env.PUBLIC_URL}/assets/headerPictures/cooking2.webp` },
    { name: "garden", pic:`${process.env.PUBLIC_URL}/assets/headerPictures/arti-android-chrome-192x192.webp` },
    { name: "chickens", pic:`${process.env.PUBLIC_URL}/favicons/android-chrome-192x192.png` },
    { name: "dogs", pic:`${process.env.PUBLIC_URL}/assets/headerPictures/xena-android-chrome-192x192.webp` },
    { name: "goats", pic:`${process.env.PUBLIC_URL}/assets/headerPictures/tandmg-android-chrome-192x192.webp` },
    { name: "sky", pic:`${process.env.PUBLIC_URL}/assets/android-chrome-192x192.png` },
    { name: "wildlife", pic:`${process.env.PUBLIC_URL}/assets/headerPictures/pic-android-chrome-192x192.webp` }
];


const AlbumHeader = ({ currentAlbum, albumType = 'videos' , onAlbumSelect, unfilteredList = []}) => {
    return (
        <div className="container">
            <div className="row text-center small-hide">
                <div
                    className={`mx-auto ${
                        albumType === 'videos' ? 'col-lg-12' : 'col-lg-9'
                    }`}
                    style={{ display: 'flex' }}
                >
                    {albumCovers.map((album, index) => (
                        <div
                            key={album.name}
                            className={`text-center ml-2 mr-2 cursPoint ${
                                album.name === currentAlbum ? 'highlighted' : ''
                            }`}
                            onClick={() => onAlbumSelect(album.name)}
                            style={{ padding: '10px' }}
                            hidden={(albumType !== 'pictures' && album.hide_video_view)||(albumType == 'pictures' && album.hide_pic_view)}
                        >
                      <span>
                            <img className="br20" src={album.pic} height="100em" alt={album.name} />
                            <p className="text-white text-small text-center">{titleCaps(album.name)}</p>
                      </span>
                        </div>
                    ))}
                </div>
            </div>
            <div className="row text-center big-hide album-header-inner">
                <div className="col-xs-12 x-scroller" style={{ justifyContent: 'center' }}>
                    {albumCovers.map((album, index) => (
                        <div
                            key={album.name}
                            className={`text-center cursPoint ${
                                album.name === currentAlbum ? 'highlighted' : ''
                            }`}
                            onClick={() => onAlbumSelect(album.name)}
                            style={{ padding: '10px' }}
                            hidden={(albumType !== 'pictures' && album.hide_video_view)|| (albumType == 'pictures' && album.hide_pic_view)}
                        >
                      <span style={{ height: '65px', width: '65px', display: 'inline-block' }}>
                            <img className="br20" src={album.pic} height="60px" width="60px" alt={album.name} />
                            <p className="text-white text-small text-center">{titleCaps(album.name)}</p>
                      </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AlbumHeader;